module.exports = __webpack_public_path__ + "img/f5384efc-eadb-4d7b-a131-36516269c218.96b7670b.jpg";